// Styling
import style from "./btn.module.scss";

// Components
// import Link from "next/link";

export default function Btn({ button, btnStyle = "" }) {
  if (button === null) {
    return;
  }
  return (
    <a
      href={button.url}
      target={button.target}
      className={style.btn}
      data-style={btnStyle}
    >
      {button.title}
    </a>
  );
}
